<template>
  <div>
    <slot :changeLocale="changeLocale" :currentLocale="currentLocale" :locales="locales"></slot>
  </div>
</template>

<script>
import { LOCALES } from '@/util/i18n/locale';
import { localize } from '@/util/i18n/localize';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LocaleProvider',
  computed: {
    ...mapGetters('auth', ['authenticated']),
    currentLocale() {
      return this.$i18n.locale;
    },
    locales() {
      return LOCALES;
    },
  },
  methods: {
    ...mapActions('auth', ['saveLocale']),
    changeLocale(locale) {
      if (this.authenticated) {
        this.saveLocale(locale); // async
      }

      localize(locale);
    },
  },
};
</script>
